import React from 'react';
import { Btn, Chip } from './ui';
import { C, BADGES } from '../data/constants';

export default function BadgeDetail({ badgeIndex, onBack, onPlay, player }) {
  const b        = BADGES[badgeIndex];
  const isEarned = (player?.earnedBadges || []).includes(badgeIndex);

  if (!b) return null;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Back */}
      <div onClick={onBack} style={{ background: '#fff', display: 'flex', alignItems: 'center', gap: 6, padding: '12px 16px', borderBottom: `2px solid ${C.border}`, cursor: 'pointer', color: C.muted, fontSize: 13, fontWeight: 700, flexShrink: 0 }}>
        ← Back to Titles
      </div>

      <div className="scroll-area">
        {/* Hero */}
        <div style={{ background: 'linear-gradient(180deg,#FFF9E8,#FFFAF2)', padding: '24px 16px', textAlign: 'center', borderBottom: `2px solid ${C.border}` }}>
          <div className="pop" style={{ fontSize: 56, marginBottom: 10 }}>{b.ic}</div>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: C.muted, marginBottom: 6 }}>{b.tier}</div>
          <div style={{ fontSize: 22, fontWeight: 900, lineHeight: 1.2, marginBottom: 4 }}>{b.name}</div>
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 12 }}>{b.civ}</div>
          <Chip type={isEarned ? 'gr' : 'bl'}>{isEarned ? '✅ Earned!' : '🔒 Not earned yet'}</Chip>
        </div>

        {/* Quote */}
        <div style={{ padding: 16 }}>
          <div style={{ background: '#FFFBF0', borderLeft: `4px solid ${C.amber}`, borderRadius: '0 12px 12px 0', padding: '12px 14px', marginBottom: 14 }}>
            <div style={{ fontSize: 14, fontStyle: 'italic', color: C.text, lineHeight: 1.7 }}>{b.quote}</div>
          </div>

          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: C.muted, marginBottom: 8 }}>The Story 📖</div>
          <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.7, marginBottom: 14 }}>{b.story}</div>
        </div>

        {/* How to earn */}
        <div style={{ background: isEarned ? '#E8F8F0' : '#F5F5F5', borderTop: `2px solid ${isEarned ? '#90DEB8' : C.border}`, borderBottom: `2px solid ${isEarned ? '#90DEB8' : C.border}`, padding: '14px 16px', display: 'flex', gap: 10, marginBottom: 14 }}>
          <div style={{ fontSize: 22 }}>{isEarned ? '✅' : '🎯'}</div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: isEarned ? C.green : C.muted, marginBottom: 4 }}>
              {isEarned ? 'You earned this!' : 'How to earn this'}
            </div>
            <div style={{ fontSize: 12, color: C.muted, lineHeight: 1.6 }}>{b.how}</div>
          </div>
        </div>

        {/* Physical reward */}
        {b.reward && (
          <div style={{ margin: '0 16px 14px', background: '#FFF9E8', border: `2px solid ${C.goldLight}`, borderRadius: 16, padding: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: C.amber, marginBottom: 8 }}>🎁 Physical Reward!</div>
            <div style={{ fontSize: 13, color: C.text, lineHeight: 1.6, fontWeight: 500 }}>{b.reward}</div>
          </div>
        )}

        <div style={{ padding: '0 16px 24px' }}>
          {!isEarned && <Btn variant="green" onClick={onPlay}>🎮 Practice Now!</Btn>}
          <Btn variant="white" onClick={onBack}>← Back</Btn>
        </div>
      </div>
    </div>
  );
}
